/**
 * Shared ETV-Einladung fetch state (handler + onOwnersMeetingInvitationPageMatch.js).
 * Path lib/fetch/ loads before lib/luxFetchHandlers/ in the gulp bundle.
 */
const luxOwnersMeetingInvitationFetchState = {
  lastDocumentDate: '',
  lastIncludeInformationForOwners: true,
  /** Once the user edits the date field, do not re-apply lastDocumentDate from observer/init. */
  documentDateDirty: false,
}
